export const ENTITY = 'user-management';
export const ENTITY_USER_META = 'user-meta';
